export const uniqueId = (
  (counter) =>
  (str = '') =>
    // eslint-disable-next-line no-param-reassign
    `${str}${++counter}`
)(0);
